/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Never_ExpiresInputs */



/**
* | output |
* | --- |
* | "Never" |
*
* @param {Profile_Security_User_Api_Key_Never_ExpiresInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_never_expires = /** @type {((inputs?: Profile_Security_User_Api_Key_Never_ExpiresInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Never_ExpiresInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nie")
	return /** @type {LocalizedString} */ ("Never")
});